import type { FC, ReactNode } from 'react'

export interface EmptyProps {
  title: string
  /**
   * Why the screen is empty and what to do about it. Pass an array and each
   * entry becomes a line — "no data" on its own tells a site engineer nothing.
   */
  body: ReactNode | ReadonlyArray<string>
  actions?: ReactNode
}

export const Empty: FC<EmptyProps> = ({ title, body, actions }) => (
  <div className="empty">
    <div className="empty__title">{title}</div>
    <div className="empty__body">
      {Array.isArray(body) ? (
        <ul className="empty__list">
          {(body as ReadonlyArray<string>).map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      ) : (
        (body as ReactNode)
      )}
    </div>
    {actions ? <div className="empty__actions">{actions}</div> : null}
  </div>
)
